import React from "react";
import { Modal } from "../../elements/Modal";
import TableRow from "./TableRow";
import { useTranslation } from "react-i18next";
import {
  AddButton,
  IncludesCarousel,
  Nutrient,
  NutrientsCarousel,
  Quantity,
  ResetButton,
} from "../../../Constants";

const IngredientsModal = ({
  open,
  handleClose,
  data,
  setData,
  setError,
  setPrices,
  ingredients,
  pricesData,
  quantitiesChanged,
  setAddIngredientsModal,
  allIngredients,
  allIngredientCodes,
  onRemoveQuantity,
  onAddQuantity,
  prices,
  removeIngredientFromBin,
  onInputChange,
  setQuantitiesChanged,
  name,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      handleClose={handleClose}
      className="t-w-full t-max-w-[90vw] t-max-h-[80vh] md:t-max-h-[50vh] !t-px-4 t-overflow-scroll hide-scrollbar"
      childrenClass=""
      enableClickOutsideClose={false}
    >
      <div className="t-h-full t-flex t-flex-col t-items-center t-justify-center t-gap-4 t-py-4 t-overflow-scroll ">
        <div className="t-w-full t-flex t-items-center t-justify-between t-gap-2 t-scale-x-90 xs:t-scale-x-100">
          <div className="t-flex t-flex-col t-items-start ">
            <h1
              className="!t-m-0 !t-text-secondary !t-font-extrabold"
              style={{ fontFamily: "Roboto" }}
            >
              {name}
            </h1>
            <p className="!t-m-0 t-text-gray-500">
              {t(IncludesCarousel)} {data?.length} {t(NutrientsCarousel)}
            </p>
          </div>
          <div className=" t-flex t-flex-wrap t-items-end t-justify-end t-gap-4">
            <button
              className="t-group btn !t-w-fit !t-px-3 text-capitalize btn-custom-quaternary !t-rounded-md !t-py-1"
              onClick={() => {
                setQuantitiesChanged(false);
                setData(ingredients);
                setError({});
                setPrices(pricesData);
              }}
              disabled={!quantitiesChanged}
            >
              {t(ResetButton)}
            </button>
            <button
              className="btn !t-w-fit text-capitalize btn-custom-quaternary !t-rounded-md !t-py-1 !t-px-3"
              onClick={() => setAddIngredientsModal(true)}
            >
              {t(AddButton)}
            </button>
          </div>
        </div>
        <div className="table-responsive t-scale-x-90 xs:t-scale-x-100">
          <table className="table accordion" id="accordionExample">
            <thead>
              <tr>
                <td className="t-text-[11px] md:t-text-sm t-w-[30%] md:t-w-[40%] t-font-bold">
                  {t(Nutrient)}
                </td>
                <td className="t-text-[11px] md:t-text-sm t-text-center t-font-bold">
                  {t(Quantity)}
                </td>
                <td className="t-text-[11px] md:t-text-sm !t-text-center t-font-bold">
                  %NRV
                </td>
                <td className="t-text-[11px] md:t-text-sm !t-text-center t-font-bold">
                  €
                </td>
                <td className="t-text-[11px] md:t-text-sm !t-text-center t-font-bold"></td>
              </tr>
            </thead>
            <tbody>
              {data &&
                data.map((item, i) => {
                  const ingredient = allIngredients?.data?.find(
                    (ing) =>
                      ing.ingredient === item?.ingredient ||
                      ing.ingredient_de === item?.ingredient
                  );
                  const ingredientData = allIngredientCodes?.data?.find(
                    (ing) => ing?.code === ingredient?.id
                  );
                  const euNrv = parseFloat(ingredientData?.eu_nrv);
                  return (
                    <TableRow
                      key={"ingredient-" + i}
                      item={item}
                      i={i}
                      onRemoveQuantity={onRemoveQuantity}
                      ingredientData={ingredientData}
                      onAddQuantity={onAddQuantity}
                      prices={prices}
                      removeIngredientFromBin={removeIngredientFromBin}
                      euNrv={euNrv}
                      onInputChange={onInputChange}
                    />
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    </Modal>
  );
};

export default IngredientsModal;
